// src/pages/Home.js
import React from 'react';
import ImageSlider from '../component/ImagesSlider';
import image1 from '../assets/images/flat.jpg';
import image2 from '../assets/images/eldeco-flat.jpeg';
import image3 from '../assets/images/land.jpg';
import logo from '../assets/images/PlacezioLogo.png'
import BottomNav from '../component/BottomNav';
import PropertyCard from '../component/PropertyCard';
import Arealist from "../component/Arealist"
import WhatsAppButton from '../component/Whatsappbtn';
import ProjectCardDetails from "./projectDetails/ProjectCardDetails"
import TotalWorkBannner from './Totalworkdata';
import About from './About';
import Rent_property from './Rent/Rent_property';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Sell_property_Card from '../component/Sell_property/Sell_property_card';
import FAQ from '../component/FAQ/FAQ';
import BlogSlider from './Blog/BlogSlider';
import Room_rent_in_society from '../component/Appartment_rent_in_society/Appartment_rent_in_society';
import { useState,useEffect } from 'react';
import { API_URL } from '../common/constant';
import axios from 'axios';


const Home = () => {
    const navigate = useNavigate()

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [properties, setProperties] = useState([]);

    useEffect(() => {
        const fetchProperties = async () => {
            setLoading(true);
            try {
                const response = await axios.get(`${API_URL}/api/rentApartment/rent-apartments`);
                console.log("API Response:", response);
                
                // Ensure properties exist before setting state
                if (response.data && Array.isArray(response.data.apartments)) {
                    setProperties(response.data.apartments);
                } else {
                    setProperties([]);
                }
            } catch (err) {
                console.error("Error fetching properties:", err);
                setError("Failed to load properties. Please try again later.");
                setProperties([]);
            } finally {
                setLoading(false);
            }
        };
        fetchProperties();
    }, []);

    const handleNavigate = (id) => {
        navigate(`/appartment_details/${id}`);
    };

    const list_property = () => {
        navigate("/list-Property")
    }

    return (
        <>
            <Helmet>
                <title>Placezio Estate - Properties for Rent & Sale | Find Your Dream Home</title>
                <meta name="description" content="Placezio Estate offers a variety of rental and sale properties, including flats, villas, and plots. Find your perfect property today!" />
                <meta name="keywords" content="properties for rent,properties for rent in lucknow,  flat for rent in lucknow, affordable flat in lucknow for rent, real estate listings, flats for rent, villas for sale, plots for sale, real estate India" />
                <meta property="og:title" content="Placezio Estate - Properties for Rent & Sale" />
                <meta property="og:description" content="Browse properties for rent and sale at Placezio Estate. Find flats, villas, and plots in your ideal location." />
                <meta property="og:image" content={logo} />
                <meta property="og:url" content="https://placezioestate.com/" />
                <link rel="canonical" href="https://placezioestate.com/" />
            </Helmet>
            <ImageSlider />

            <div className='text-center'>

                <h2 className='my-10' style={{ color: '#54BD95' }}>────୨ৎ────</h2>

            </div>

            <div className='text-center'>
                <h2 className="text-4xl md:text-5xl mt-4 " style={{ color: '#54BD95' }}>
                    What We Offer
                </h2>
            </div>


            <div className="text-center px-4 "> {/* px-4 for mobile padding */}
                <div className="p-3   mt-8 ">
                    <About />
                </div>


                <h2 className='my-10' style={{ color: '#54BD95' }}>────୨ৎ────</h2>


                <div
                    className="flex bg-[#54BD95] lg:p-2 lg:mx-24 mt-12 justify-between items-center"
                    style={{
                        height: "100%",
                        boxShadow: "0px 4px 15px rgba(141, 231, 177, 0.9)" // Add black shadow
                    }}
                >
                    <div className="px-4">
                        <h2 className="text-white" style={{ fontSize: "30px" }}>List Your Property</h2>
                        <p className="font-bold text-white text-lg">Free Property Listing on Placezio Estate</p>
                    </div>
                    <div>
                        <button
                            className="bg-white text-[#54BD95] px-3 mx-2 py-2 rounded hover:bg-[#45a68b] hover:text-white"
                            onClick={list_property}
                        >
                            List your Property
                        </button>
                    </div>
                </div>
                <div className='text-center'>

<h2 className='my-10' style={{ color: '#54BD95' }}>────୨ৎ────</h2>
<h2 className="text-4xl text-center mt-2 text-[#54BD95] mb-4">
Flats for Rent in Lucknow
</h2>
    <Room_rent_in_society properties={properties} loading={loading} error={error}/>

             </div>

                <h2 className='my-10' style={{ color: '#54BD95' }}>────୨ৎ────</h2>

                <Rent_property />

               
                <div className='text-center'>

                    <h2 className='my-10' style={{ color: '#54BD95' }}>────୨ৎ────</h2>
                    <Sell_property_Card />

                </div>




                <WhatsAppButton />

                <h2 className='my-10' style={{ color: '#54BD95' }}>────୨ৎ────</h2>


                <div className='my-10'>
                    <BlogSlider />
                </div>


                <h2 className='my-10' style={{ color: '#54BD95' }}>────୨ৎ────</h2>

                <div className='my-10'>
                    <TotalWorkBannner />
                </div>




                <h2 className='my-10' style={{ color: '#54BD95' }}>────୨ৎ────</h2>


                <div>
                    <FAQ />
                </div>


            </div>
            <BottomNav />
        </>
    );
};

export default Home;
